export default {
      id: "ic_circle-facebook-usage",
      viewBox: "0 0 85 85",
      url: "/" + "images/icons.3.109.2.svg#ic_circle-facebook-usage",
      toString: function () {
        return this.url;
      }
    }